module.exports = __webpack_public_path__ + "assets/img/icon_sound_mute.c5d5ef68.svg";